export default __webpack_public_path__ + "static/media/avo-planet.f5126648.png";